import { logDevelopmentMessage } from './logDevelopmentMessage'
import { initScript } from '../loadConferWith'

export interface IPollForWidgetFlagArgs {
  onTimeElapsed?: () => void
  maxWaitTime?: number
}

export function pollForWidgetFlagAndShowAppropriateWidget(args?: IPollForWidgetFlagArgs) {
  let elapsedTime = 0
  const checkInterval = 5000 // Check every 5 seconds
  const maxWaitTime = args?.maxWaitTime || 30000 // Stop checking after 30 seconds

  const interval = setInterval(() => {
    logDevelopmentMessage('Checking for hideSalesLiveChat property...')
    elapsedTime += checkInterval

    if (window.hideSalesLiveChat === true) {
      clearInterval(interval)
      logDevelopmentMessage('hideSalesLiveChat is true, initializing ConferWith instead')
      initScript('https://live.conferwith.io/cdn/conferwith_widget.js')
    } else if (elapsedTime >= maxWaitTime) {
      clearInterval(interval)
      logDevelopmentMessage('invoking `onTimeElapsed` callback')
      args?.onTimeElapsed?.()
    }
  }, checkInterval)

  return interval // Return interval ID for cleanup if needed
}
